import useStyles from './EmbedVideo.styled'

export const useEmbedVideo = props => {
	const { className, objectFit, shading, metaData, autoplay } = props
	const classes = useStyles(props)

	return [
		{
			classes,
			className,
			src: metaData?.videoUrl({ autoplay: autoplay ? '1' : '0' }),
			showOverlay: shading > 0,
			objectFit,
		},
	]
}
